import React, { useEffect, useState, useRef } from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import { toast } from 'react-toastify';

export default function MusicTab(props) {
  console.log('showMusicTab', props.showMusicTab);
  return (
    <>
      <div className="nft__tab_pane nft__tab__pane--scroll" role="tabpanel">
        {props.nftData &&
          props.nftData.icons &&
          props.nftData.icons.map((ele, indx) => {
            return (
              <div
                className={`nft__tab_content flex items-center px-3 py-3 music_file_comp ${
                  props.audioIndex === indx ? 'music_file_comp_active' : ''
                }`}
                key={'music_file_' + indx}
                onClick={() => {
                  if (props.showMusicTab) {
                    props.setaudioPlayerMode('full');

                    if (props.audioPlaying) {
                      if (props.audioPlaying && props.audioIndex === indx) {
                        props.audioInstance.current.pause();
                      } else {
                        props.audioInstance.current.playByIndex(indx);
                        props.setaudioPlaying(true);
                      }
                    } else if (props.audioIndex === indx) {
                      props.setaudioPlayerMode('full');
                      props.audioInstance.current.play();
                      props.setaudioPlaying(true);
                    } else {
                      props.setaudioPlayerMode('full');
                      props.audioInstance.current.playByIndex(indx);
                      props.setaudioPlaying(true);
                    }
                  } else {
                    toast.info('Only NFT owner can play the Track.', {
                      position: 'bottom-left',
                      autoClose: 10000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      toastId: 'nftdetails_toast',
                    });
                  }
                }}
              >
                <div
                  className={`mr-2 ${
                    props.audioIndex === indx
                      ? 'music_file_comp_active_text'
                      : ''
                  }`}
                >
                  {props.audioPlaying && props.audioIndex === indx ? (
                    <PauseIcon />
                  ) : (
                    <PlayArrowIcon />
                  )}
                </div>
                <div
                  className={`${
                    props.audioIndex === indx
                      ? 'music_file_comp_active_text'
                      : ''
                  }`}
                >
                  {props.nftData &&
                  props.nftData.audioFileNames &&
                  props.nftData.audioFileNames[indx]
                    ? props.nftData.audioFileNames[indx]
                    : 'unknown'}
                </div>
                <div
                  className={`ml-auto ${
                    props.audioIndex === indx
                      ? 'music_file_comp_active_text'
                      : ''
                  }`}
                >
                  {props.nftData.audioFilesDuration &&
                  props.nftData.audioFilesDuration[indx]
                    ? props.nftData.audioFilesDuration[indx]
                    : ''}
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
}
